<!--
	SearchPage.svelte

    Contains the following components:

        <SearchFiltersPanel>
        <AuthServiceList>
-->

<script>
    import { onMount } from 'svelte';
    import { fly, fade } from 'svelte/transition';
    import { push } from 'svelte-spa-router';

    import { isRunningSearch, isShowingSearchResults, currentListItemId } from '../../stores/ScreenSettingsStore';
    import { setInfoAlert, setErrorAlert } from '../../stores/AlertsStore';
	import { fetchAllFieldsPresets } from '../../stores/FieldPresetsStore.js';

    import { AccountStore } from "../../common/account.ts";

    // 5/12 - the master search object (store)
	import { masterSearch } from '../../common/master-objects.js';

    // TCARE components
    import PageBanner from '../../components/common/PageBanner.svelte';
	import AuthSearchPanel from '../../components/searches/AuthSearchPanel.svelte';
	import AuthServiceList from '../../components/lists/AuthServiceList.svelte';
    import CircularSpinner from '../../components/common/CircularSpinner.svelte';

    $: flyInDurMsecs = $currentListItemId === '' ? 500 : 0;     // no fly in if scrolling to item

    const ADD_TO_COLL_MSG = 'Services added to Collection OK';
    const ADD_TO_COLL_ERROR = 'There was a problem adding Services';

    onMount(() => {
        // console.log('');
        // console.log('SearchPage onMount');
        // console.log('$currentListItemId');
        // console.log($currentListItemId);

        if (!$AccountStore?.isLoggedIn) {
            push('/');                                  // and login
        }

		fetchAllFieldsPresets();

        // scroll to opened item, if exists - use store?
        // must set item CSS: scroll-margin-top: 55px;
        scrollTo(0, 0);
        if ($currentListItemId !== '') {
            scrollToMarker($currentListItemId);
            $currentListItemId = '';                // clear it
        }
    })

    const onAddToCollection = (json) => {
        if (!json.errors) {
            setInfoAlert(ADD_TO_COLL_MSG, 1000);
        } else {
            setErrorAlert(ADD_TO_COLL_ERROR, 2000);
        }
    }

    // must set item CSS: scroll-margin-top: 55px;
    const scrollToMarker = (id) => {
        let marker = document.getElementById(id);
        if (marker) {
            // console.log("scrolling to ", marker);
            marker.scrollIntoView({behavior: 'smooth'});
        }
    }

</script>


<style>

    .sub-title {
        margin-top: -20px;
        letter-spacing: .2px;
        font-size: 14px;
        color: var(--tcare-purple);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }
</style>


<div class="page-content search-page" in:fly="{{ x: 200, duration: flyInDurMsecs }}" out:fade="{{ duration: 250 }}">
    <PageBanner title="Search Services"/>
    <div class="sub-title">Enter your own custom text or search by text, region and keywords below.</div>

    <div class="spacer-h-25"></div>
    <AuthSearchPanel store={masterSearch} />

    {#if $isRunningSearch}
        <div class="search-progress">
            <CircularSpinner delay={500} label={'Searching services...'}  />
        </div>
    {:else}
        {#if $isShowingSearchResults}
            <AuthServiceList store={masterSearch} {onAddToCollection}/>
        {/if}
    {/if}

    <div class="spacer-h-50"></div>
</div>
